import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import catchCancel from 'helpers/catchCancel';
import { CROPWISE_PROXY_V2_URL } from 'utilities/apiConstants';
import { getAccessToken } from 'utilities/base-auth';

const alphabeticalSort = (a, b) => a.name.localeCompare(b.name);

const useCropsWithLoads = cropSeasonId => {
  const [isLoading, setIsLoading] = useState(false);
  const [crops, setCrops] = useState(null);

  const getCropsWithLoads = useCallback(() => {
    if (!cropSeasonId) return;

    setIsLoading(true);
    const orgId = localStorage.getItem('selectedOrganizationId');

    const promise = axios.get(
      `${CROPWISE_PROXY_V2_URL}/yield/summary/crop-season/${cropSeasonId}/crops`,
      {
        headers: {
          'Content-Type': 'application/json',
          'cwf-context': JSON.stringify({
            organization_id: orgId
          }),
          Authorization: `Bearer ${getAccessToken()}`
        }
      }
    );

    promise
      .then(({ data }) => {
        setCrops(data.sort(alphabeticalSort));
      })
      .catch(catchCancel)
      .finally(() => setIsLoading(false));
  }, [cropSeasonId]);

  useEffect(() => {
    getCropsWithLoads();
  }, [getCropsWithLoads]);

  return {
    getCropsWithLoads,
    loading: isLoading,
    crops
  };
};

export default useCropsWithLoads;
